import { render } from "./DeliveryManagement.vue?vue&type=template&id=a2e03fe8&scoped=true"
import script from "./DeliveryManagement.vue?vue&type=script&lang=js"
export * from "./DeliveryManagement.vue?vue&type=script&lang=js"

import "./DeliveryManagement.vue?vue&type=style&index=0&id=a2e03fe8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2e03fe8"]])

export default __exports__